import { Box, makeStyles, Theme, Typography } from "@material-ui/core";
import { Tabs } from "@roc/ui";
import { useState } from "react";
import { InspectionPhoto } from "../types/types";

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    backgroundColor: "transparent !important",
    border: "0 !important",
    borderBottom: `2px solid #EEEEEE !important`,
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& > div": {
      paddingBottom: "0px !important",
    },
    "& .MuiTabs-flexContainer": {
      gap: "3px",
    },
    "& .MuiTabs-root": {
      paddingLeft: "1rem",
    },
  },
  tab: {
    backgroundColor: "#F7F7F7",
    color: "#000000",
    fontSize: "0.9rem",
    borderRadius: "10px 10px 0px 0px",
    border: "none",
    borderBottom: "none",
    width: "fit-content",
    maxWidth: "none",
    "& .MuiTab-root": {
      minWidth: "14rem !important",
    }
  },
  activeTab: {
    backgroundColor: "#EEEEEE",
    fontWeight: 700,
    color: "#000000",
  },
  tabContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gridGap: "0.5rem",
    minHeight: "590px"
  },
}));

interface PhotoMetadataProps {
  inspectionPhoto: InspectionPhoto;
}

export const PhotoMetadata = ({ inspectionPhoto }: PhotoMetadataProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const classes = useStyles();

  const tabs = [
    {
      label: "DEVICE",
      value: "DEVICE",
    },
    {
      label: "LOCATION",
      value: "LOCATION",
    }
  ];

  const onTabChangeHandler = (_, index) => {
    setTabIndex(index);
  };

  const deviceData = inspectionPhoto.deviceData;
  const locationData = inspectionPhoto.locationData;

  const deviceTab = (<Box className={classes.tabContent}>
    <MetaDataValue title="ID" description={deviceData.deviceId} />
    <MetaDataValue title="Make and Model" description={deviceData.deviceModel} />
    <MetaDataValue title="Platform" description={deviceData.platform} />
    <MetaDataValue title="OS Version" description={deviceData.osVersion} />
    <MetaDataValue
      title="App Version"
      description={deviceData.appVersion}
    />
    <MetaDataValue title="User Agent" description={deviceData.userAgent} />
    <MetaDataValue title="Screen Resolution" description={deviceData.screenResolution} />
    <MetaDataValue title="Locale" description={deviceData.locale} />
    <MetaDataValue title="Timestamp ISO" description={deviceData.timestampISO} />
  </Box>);

  const locationTab = (<Box className={classes.tabContent}>
    <MetaDataValue title="Latitude" description={locationData.latitude} />
    <MetaDataValue title="Longitude" description={locationData.longitude} />
    <MetaDataValue title="Timestamp" description={locationData.timestampISO} />
    <MetaDataValue title="Accuracy" description={locationData.accuracy} />
    <MetaDataValue
      title="Altitude Accuracy"
      description={locationData.altitudeAccuracy}
    />
    <MetaDataValue title="Altitude" description={locationData.altitude} />
    <MetaDataValue title="Speed" description={locationData.speed} />
    <MetaDataValue title="Heading" description={locationData.heading} />
  </Box>);

  return (
    <>
      <Tabs
        tabs={tabs}
        tabClassName={classes.tab}
        tabSelectedClassName={classes.activeTab}
        className={classes.tabs}
        selectedTab={tabIndex === -1 ? 0 : tabIndex}
        onTabChange={onTabChangeHandler}
      />
      {tabIndex === 0 && deviceTab}
      {tabIndex === 1 && locationTab}
    </>
  );
};

const dataValueStyle = {
  border: "1px solid #ddd",
  padding: "1rem",
  borderRadius: 8,
};

const MetaDataValue = ({ title, description }) => {
  return (
    <Box
      style={dataValueStyle}
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gridGap={2}
    >
      <Box gridColumn="span 3">
        <Typography variant="body1">{title}</Typography>
      </Box>
      <Box gridColumn="span 9">
        <Typography variant="body2">{description}</Typography>
      </Box>
    </Box>
  );
};
